import { useQuery } from "@tanstack/react-query";
import { integrationApi } from "@repo/api";

export const useIntegrationTypeFeatures = (integrationType: string) => {
  return useQuery({
    queryKey: ["integrationTypeFeatures", integrationType],
    queryFn: () => integrationApi.getIntegrationTypeFeatures(integrationType),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
